$(document).ready(function () {
    requiredFilesInPattern();
});

function requiredFilesInPattern() {
    var inpFilesList = getObj(REQUIRED_FILES_LIST_INPUT).value;
    if (inpFilesList.trim() === '')
        return;

    var listFiles = inpFilesList.split("\n");
    var requiredFiles = [];
    
    for (var i = 0; i < listFiles.length; i++) {
        if (listFiles[i].trim().length > 0)
            requiredFiles[requiredFiles.length] = { id: requiredFiles.length + 1, Nome: listFiles[i].trim() };
    }

    setDocListInCaptureModule(requiredFiles);
}

function setDocListInCaptureModule(docList) {
    captureModule.vars.docList = docList;
    captureModule.capture.load();

    var onlyRequiredFiles = document.getElementById(ONLY_REQUIRED_FILE_INPUT).value;
    if (onlyRequiredFiles.toLowerCase() === 'true' && docList.length <= 0)
        $('#div-msg-attach-documents').show();
    else
        $('#div-msg-attach-documents').hide();
}


// função anônima autoexecutável para delimitar escopo
(function (global, captureModule) {


	function RequiredFiles(token) {
		this.baseUrl = '../api/2.0/';
		this.token = token;
		this.businessRules = [];
		this.businessRulesDetails = [];
		this.businessRulesInputs = [];
	}

	// Método estático, por isso não tem o .prototype
	RequiredFiles.processOnlyRequiredFilesOption = function() {
		var onlyRequiredFiles = document.getElementById(ONLY_REQUIRED_FILE_INPUT).value;
		if (onlyRequiredFiles.toLowerCase() === 'true') {
			// remove botao de anexos original
            $('#annex button').remove();
		}
	};

	// requisita os detalhes da regra de negócio
	RequiredFiles.prototype.requestBusinessRule = function (codBre) {

		var _this = this;
		//TODO: Deveria consultar api interna
		return $.ajax({
			url: _this.baseUrl + 'businessrules/' + codBre,
			method: 'GET',
			headers: { 'Authorization': _this.token }
		});

	};

	RequiredFiles.prototype.parseBusinessRule = function(businessRuleCod, breRule) {

		/*
		Detalhes de regra no formato
		{
			CodBre: 1,
			DsBreTitle: 'Regras Basicas',
			BreRule:[
				{
					CodBreRule: 1
					DsRuleTitle: 'Nacionalidade',
					StReturnType: 'string',
					DsReturn: 'Texto definido como retorno',
					BreRuleCondition:[
						{
							CodRuleCondition: 1,
							DsValue: 'Estrangeiro',
							DsFlowResult: null,
							VlOrder: 1,
							DsParentesisLeft: '',
							DsParentesisRight: '',
							DsMathOperator: '=',
							DsLogicalOperator: 'AND',
							DsFieldName: 'Nacionalidade',
							CodFlowResult: null,
							CodRuleCondition: 4
						}
					]
				}
			]
		}
		*/

		var businessRuleDetail;

		for (var i = 0; i < breRule.length; i++) {

			businessRuleDetail = breRule[i];
			this.businessRulesDetails.push(businessRuleDetail);

			this.parseRuleConditions(businessRuleDetail.breRuleCondition, businessRuleCod);

		}

	};

	RequiredFiles.prototype.parseRuleConditions = function(ruleConditions, businessRuleCod) {

		var businessRulesInput;

		for (var i = 0; i < ruleConditions.length; i++) {

			businessRulesInput = $('[xname=inp' + ruleConditions[i].dsFieldName + ']');

			if (businessRulesInput[0]) {

				var dataRule = businessRulesInput[0].getAttribute('data-rule');

				if (!dataRule) {
					businessRulesInput[0].setAttribute('data-rule', businessRuleCod);
					businessRulesInput[0].setAttribute('dependente-regra', true);
					businessRulesInput[0].addEventListener('change', this.changeHandler.bind(this));
					this.businessRulesInputs.push(businessRulesInput[0]);
					continue;
				}

				dataRule += ',' + businessRuleCod;
				businessRulesInput[0].setAttribute('data-rule', dataRule);

			}

		}

	};

	RequiredFiles.prototype.changeHandler = function(evento) {
		this.validateBusinessRule(evento.currentTarget);
	};

	// dispara a validação inicial
	RequiredFiles.prototype.addRuleTriggers = function () {
		for (var i = 0; i < this.businessRulesDetails.length; i++) {
			for (var j = 0; j < this.businessRulesDetails[i].breRuleCondition.length; j++) {
				input = $('[xname=inp' + this.businessRulesDetails[i].breRuleCondition[j].dsFieldName + ']');
				if (input[0]) {
                    this.validateBusinessRule(input[0]);
                    break;
				}
            }
            break;
		}
	};

	RequiredFiles.prototype.validateBusinessRule = function(input) {

		var businessRuleCode = input.getAttribute('data-rule');
		var formData = this.getFormData();

		// se o campo estiver associado a mais de uma regra de negócio
		if (businessRuleCode.indexOf(',') > -1) {
			var businessRuleCodes = businessRuleCode.split(',');
			for (var i = 0; i < businessRuleCodes.length; i++) {
                this.validateBusinessRulesRequest(businessRuleCodes[i], formData);
                break;
			}
			return;
		}

		this.validateBusinessRulesRequest(businessRuleCode, formData);

	};


	RequiredFiles.prototype.validateBusinessRulesRequest = function(businessRuleCode, formData) {

		var _this = this;
		//TODO: Deveria consultar api interna
		$.ajax({
			url: _this.baseUrl + 'businessrules/' + businessRuleCode + '/evaluate',
			method: 'POST',
			headers: {
				'Authorization': _this.token,
				'Content-Type': 'application/json'
			},
			// dataType: 'json', // a propriedade headers sobrescreve isso
			data: JSON.stringify(formData)
		})
		.then(function(result, textStatus, xhr) {

			/*
			se se enquadrar em uma ou mais condições
			{ CodBreRule: 1, StReturnType: 'string', DsReturn: '/nome do documento > condicao1 > condicao2; outro nome do documento > condicao3'}, CodBreRule: 2, StReturnType: 'string', DsReturn: '/mais um nome do documento > condicao4'}]
			se se enquadrar no se não
			[{StElseReturnType: 'string', DsElseReturn: '??' }
			se não se enquadrar em nenhuma condição
			[{StElseReturnType: '', DsElseReturn: '' }
			*/

			var businessRuleResult;
			var files = [];
			var fileList = [];

			for (var i = 0; i < result.length; i++) {

				businessRuleResult = result[i];

				if (businessRuleResult.hasOwnProperty('stElseReturnType')) {

					// se vier com formato inválido, não tomar ação

					// pré-verificação pra evitar regex
                    if (businessRuleResult.stElseReturnType === '' || businessRuleResult.stElseReturnType !== 'document') {
						break;
					}
					if (businessRuleResult.dsElseReturn === '') {
						break;
					}

                    files = JSON.parse(businessRuleResult.dsElseReturn);
					break;
				}
				else {
                    if (businessRuleResult.stReturnType === '' || businessRuleResult.stReturnType !== 'document') {
                        continue;
                    }
                }
                var jsonFiles = JSON.parse(businessRuleResult.dsReturn);
                $.each(jsonFiles, function (index, file) {
                    files.push(file);
                });
			}

            $.each(files, function (index, document) {
                if (document.Document === '')
                    return true;
			
                fileList.push({
                    id: index,
                    Nome: document.Document
                });
            });

            setDocListInCaptureModule(fileList);
		});

	};


	RequiredFiles.prototype.getFormData = function() {

		var formData = [];
		var fieldData;
		var businessRulesInput;
		var fieldName;

		for (var i = 0; i < this.businessRulesInputs.length; i++) {

			businessRulesInput = this.businessRulesInputs[i];
			fieldName = businessRulesInput.getAttribute('xname');
			fieldName = fieldName.replace(/^inp/, '');

			fieldData = {
				DsFieldName: fieldName,
				DsValue: businessRulesInput.value
			};

			formData.push(fieldData);

		}

		return formData;

	};

	$(document).ready(function() {

		RequiredFiles.processOnlyRequiredFilesOption();

		var codBre = document.getElementById('inpCodBre').value;

		if (!codBre || codBre === '0') {
			return;
		}

		var token = document.getElementById('inpToken').value;

		var requiredFiles = new RequiredFiles(token);
		requiredFiles.requestBusinessRule(codBre)
		.then(function(regras, textStatus, xhr) {

			if (!regras) {
				return;
			}

			requiredFiles.parseBusinessRule(regras.codBre, regras.bresRule);
			requiredFiles.addRuleTriggers();

		},
		function(erro) {
			// exceção da cadeia de promessas
			console.log(erro);
		});

	});



})(window, captureModule);